export class AccountData{
    constructor(
        public merchantId: String = '',
        public defaultMerchantId: String = '',
        public roleId: any = [],
        public language: String = '',
        public currency: String = '',
        public timeFormat: String = '',
        public timeZone: String = '',
        public login: String = '',
        public password: String = '',
        public repeatPassword: String = '',
        public blindToPc: String = '',
        public isEnabled: String = '',
        public pwdReset: String = '',
        public pinEnabled: String = '',
        public pin: String = '',
        public pinExpiration: String = '',
        public printingType: String = '',
        public printedId: String = '',
        public userId: String = ''
    ){}
}